import { useEffect } from "react"

export const useExitPrompt = (enabled = true): void => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (enabled) {
        event.preventDefault()
        event.returnValue = ``
      }
    }

    window.addEventListener(`beforeunload`, handleBeforeUnload)

    return () => {
      window.removeEventListener(`beforeunload`, handleBeforeUnload)
    }
  }, [enabled])
}
